export default __webpack_public_path__ + "static/media/C_Cavalo.8d0f895a.mp3";